// reducers/masterReducer.js
export const initialMasterState = {
  course_id: '',
};

export const masterReducer = (state, action) => {
  switch (action.type) {
    case "SET_COURSE_LIST":
      return {
        ...state,
        courseList: action.payload,
      };
    default:
      return state;
  }
};
